// extracted by mini-css-extract-plugin
export var productImage = "_l8-1";
export var viewLink = "_l8-2";
export var wishlistItem = "_l8-0";